module.exports = __webpack_public_path__ + "static/media/booking-confirmation.ca8d8e31.mp3";